import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import { getToken, getUserInfo } from "@/utils/auth";

router.beforeEach(async (to, from, next) => {
  const userInfo = getUserInfo();
  const hasToken = getToken();
  if (hasToken && userInfo && userInfo.status == "1") {
    if (!store.state.user.isLogin) {
      store.dispatch("user/setLoginStatus");
    }
    if (to.path == "/login") {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    // 登录过期后清除
    // store.dispatch("user/resetLoginStatus");
    // 没登录或者登录过期
    if (to.meta.needLogin) {
      // 访问需要登录的页面
      next({ path: "/login" });
      Message({
        message: "请先登录",
        type: "warning",
        duration: 2000
      });
    } else {
      next();
    }
  }
  if (to.meta.title) {
    if (to.meta.title == "首页") {
      document.title = "SHOWALL PTE. LTD.";
    } else {
      document.title = to.meta.title;
    }
  }
  //   if (hasToken) {
  //     if (to.path === "/login") {
  //       // if is logged in, redirect to the home page
  //       next({ path: "/" });
  //     } else {
  //       const hasGetUserInfo = store.getters.isLogin;
  //       if (hasGetUserInfo) {
  //         next();
  //       } else {
  //         next({ path: "/login" });
  //       }
  //     }
  //   } else {
  //     /* has no token*/
  //     if (to.path === "/login") {
  //       next();
  //     } else {
  //       next({ path: "/login" });
  //     }
  //   }
});



// WEBPACK FOOTER //
// ./src/permission.js